var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import InputMask from 'react-input-mask';
import { TextField } from '@material-ui/core';
import { formErrorMessages } from '../../../../../constants/form-error-messages';
import { NationalAccountContext } from '../../../../../contexts';
import { ReturnError, ShowSpinner, ModalButtonGroup } from '../commons';
import { modalBlurbs, nationalAccountRegex, shared, } from '../../../../../constants/NationalAccount';
export var EINInputModal = function () {
    var _a = useContext(NationalAccountContext), validResponseState = _a.validResponseState, setValidResponseState = _a.setValidResponseState, setShowModal = _a.setShowModal, setIsLoading = _a.setIsLoading, setErrorState = _a.setErrorState, errorState = _a.errorState, isLoading = _a.isLoading, enrollAgreementCode = _a.enrollAgreementCode;
    var _b = useState(''), einCodeUserInput = _b[0], seteinCodeUserInput = _b[1];
    var _c = useState(false), einNotFoundError = _c[0], setEinNotFoundError = _c[1];
    var _d = useState(false), isValidInput = _d[0], setIsValidInput = _d[1];
    var _e = useForm({
        mode: 'onSubmit',
    }), register = _e.register, handleSubmit = _e.handleSubmit, setValue = _e.setValue;
    var handleEnrollSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var alteredEINInput, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    alteredEINInput = einCodeUserInput.replace('-', '');
                    return [4 /*yield*/, enrollAgreementCode(true, validResponseState && validResponseState.agreementCodeEntered, alteredEINInput)];
                case 1:
                    response = _a.sent();
                    setIsLoading(false);
                    if (response && !response.hasError) {
                        setEinNotFoundError(false);
                        setErrorState(false);
                        setShowModal(false);
                        if (validResponseState.requiredEINState) {
                            sessionStorage.removeItem('isEnrolledInPerksProgram');
                        }
                        window.location.reload();
                    }
                    else {
                        setEinNotFoundError(true);
                        setErrorState(true);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var validateEINString = function (input) {
        var isInvalidCode = !input ||
            input.length === 0 ||
            !input.match(nationalAccountRegex.einRegex);
        setIsValidInput(!isInvalidCode);
    };
    var onBlurEINInput = function (_a) {
        var currentTarget = _a.currentTarget;
        var value = currentTarget.value;
        validateEINString(value);
    };
    var onChangeEINInput = function (_a) {
        var currentTarget = _a.currentTarget;
        var value = currentTarget.value;
        seteinCodeUserInput(value);
        validateEINString(value);
        setErrorState(false);
        setValue('einCodeInput', value);
    };
    var handleEnrollButton = function () {
        if (validResponseState.requiredEINState) {
            return einCodeUserInput && !errorState;
        }
        return isValidInput;
    };
    var cancelAgreement = function () {
        setErrorState(false);
        setShowModal(false);
        setValidResponseState(function (prevState) {
            return __assign(__assign({}, prevState), { enrollState: true });
        });
    };
    return (React.createElement("div", { "data-testid": "EINInputModal", className: "sui-flex sui-flex-col sui-justify-center sui-align-start sui-font-regular sui-text-1xl" },
        React.createElement("form", { onSubmit: handleSubmit(handleEnrollSubmit) },
            React.createElement("div", { className: "sui-flex sui-flex-col sui-justify-between sui-pb-5" }, modalBlurbs.governmentBlurbs.einDesc),
            isLoading && React.createElement(ShowSpinner, null),
            React.createElement("div", null,
                React.createElement(InputMask, { mask: "99-9999999", value: einCodeUserInput, disabled: false, maskChar: " ", onChange: onChangeEINInput, onBlur: onBlurEINInput }, function () { return (React.createElement(TextField, { fullWidth: true, label: modalBlurbs.governmentBlurbs.einInputLabel, id: "einCodeInput", placeholder: "Enter your 9 digit number", error: einNotFoundError && !!formErrorMessages.einInvalid.message, helperText: formErrorMessages.einInvalid.message, inputProps: __assign({}, register('einCodeInput', {
                        minLength: 0,
                        pattern: nationalAccountRegex.einRegex,
                    })) })); })),
            React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-between sui-align-start sui-text-base sui-pb-3" },
                React.createElement("p", null,
                    React.createElement("b", null,
                        modalBlurbs.governmentBlurbs.note,
                        " "),
                    ' ',
                    modalBlurbs.governmentBlurbs.content)),
            React.createElement("div", null, errorState && React.createElement(ReturnError, null)),
            React.createElement(ModalButtonGroup, { disabled: !handleEnrollButton(), confirmBlurb: modalBlurbs.confirm.buttons.continue, handleClose: cancelAgreement, cancelBlurb: shared.cancel }))));
};
